import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {CheckBox} from '../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {OkCancelDialog} from '../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {IconBox} from '../../../../libs/shared/ui/src/components/iconBox/iconBox';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ViewInInboxDialogProps {
  hasDismissedAlert: boolean;

  onConfirm: (hasToggledDismissal: boolean) => void;
  onCancel: () => void;
}

/*
 * Styles.
 */

const StyledColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/*
 * Component.
 */

export const ViewInInboxDialog: FC<ViewInInboxDialogProps> = ({hasDismissedAlert, onConfirm, onCancel}) => {
  const theme = useUserTheme();
  const [isDismissAlertChecked, setIsDismissAlertChecked] = useState(hasDismissedAlert);

  return (
    <OkCancelDialog
      title={<Trans id="view-in-inbox-dialog-title">View in inbox</Trans>}
      okButtonLabel={<Trans id="view-in-inbox-dialog-ok">Go to inbox</Trans>}
      onOkClick={() => onConfirm(hasDismissedAlert !== isDismissAlertChecked)}
      onRequestClose={() => {
        setIsDismissAlertChecked(hasDismissedAlert);
        onCancel();
      }}
    >
      <StyledColumnDiv>
        <Trans id="view-in-inbox-dialog-message">
          View the list of selected conversations in your inbox.
        </Trans>
        <IconBox
          iconName="warningFilledSmall"
          iconColor={theme.palette.orange.shade50}
          backgroundColor={theme.palette.orange.shade20}
        >
          <Trans id="view-in-inbox-dialog-warning">
            You may not have access to some of the conversations assigned to the selected teammate.
          </Trans>
        </IconBox>

        <CheckBox onChange={setIsDismissAlertChecked} isChecked={isDismissAlertChecked}>
          <Trans id="view-in-inbox-dialog-dont-show-again">Don&apos;t show me this again</Trans>
        </CheckBox>
      </StyledColumnDiv>
    </OkCancelDialog>
  );
};
